import axios from 'axios';

/*
*  This file contains all axios calls related to campaign Merge fields operations
*/

export const loadMergeFields = async (funnelId) => {
    const { data } = await axios.get(`/app/funnel/getFunnelMergeFields?funnelId=${funnelId}`);

    return data;
};

export const saveMergeField = async (funnelId, mergeFieldId, payload) => {
    const { data } = await axios.put(`/app/funnel/${funnelId}/mergeField/${mergeFieldId}`, payload);

    return data;
};

export const deleteMergeField = async (mergeFieldId) => {
    await axios.delete(`/app/funnel/mergeField/${mergeFieldId}`);
};

export const checkMarketingEmailIdsUsingMergeField = async (mergeFieldId) => {
    const { data } = await axios.get(`/app/funnel/marketingEmailIds/mergeField/${mergeFieldId}`);

    return data;
};
